export const DEFAULT_PAGEABLE_REQUEST = {
  page: 0,
  size: 10,
  sort: ['id,asc'],
};

export const DEFAULT_TABLE_PARAMS = {
  pagination: {
    current: 1,
    pageSize: 10,
  },
  filters: {},
  sorter: [],
};
